export default __webpack_public_path__ + "static/media/img-68.0e559619.jpg";